<div class="container" >
  <div>
    <header >

      <h1 class="title">Forms</h1>
      <div class="wizard">
        <a [routerLink]="['claimsform']" routerLinkActive="active" queryParamsHandling="preserve">
          Claims
        </a>
        <a [routerLink]="['employeeform']" routerLinkActive="active" queryParamsHandling="preserve" >
          Employee
        </a>
        <a [routerLink]="['taxform']" routerLinkActive="active" queryParamsHandling="preserve">
          Tax
        </a>
      </div>      
    </header>
       
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
